var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dealer-item" }, [
    _c(
      "div",
      {
        staticClass: "dealer-item__inner",
        style: { borderColor: _vm.dealerItem.SegmentColor }
      },
      [
        _c("div", { staticClass: "dealer-item__segments-wrap" }, [
          _vm.dealerItem.SegmentColors
            ? _c(
                "div",
                { staticClass: "dealer-item__segments" },
                _vm._l(_vm.dealerItem.SegmentColors, function(
                  segmentColor,
                  index
                ) {
                  return _c("span", {
                    staticClass: "dealer-item__segment",
                    style: { backgroundColor: segmentColor }
                  })
                }),
                0
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dealer-item__info" }, [
          _vm.dealerItem.Description
            ? _c("div", { staticClass: "dealer-item__row" }, [
                _c("p", {
                  staticClass: "dealer-item__preheadline",
                  domProps: { innerHTML: _vm._s(_vm.dealerItem.Description) }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "dealer-item__row" }, [
            _c("p", { staticClass: "dealer-item__headline" }, [
              _vm._v(_vm._s(_vm.dealerItem.Name))
            ]),
            _vm._v(" "),
            _vm.dealerItem.Address ||
            _vm.dealerItem.Zipcode || _vm.dealerItem.City ||
            _vm.dealerItem.Country
              ? _c("p", { staticClass: "dealer-item__address" }, [
                  _vm.dealerItem.Address
                    ? _c("span", { staticClass: "dealer-item__address-row" }, [
                        _vm._v(_vm._s(_vm.dealerItem.Address))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dealerItem.Zipcode || _vm.dealerItem.City
                    ? _c("span", { staticClass: "dealer-item__address-row" }, [
                        _vm._v(
                          _vm._s(_vm.dealerItem.Zipcode) +
                            " " +
                            _vm._s(_vm.dealerItem.City)
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dealerItem.Country
                    ? _c("span", { staticClass: "dealer-item__address-row" }, [
                        _vm._v(_vm._s(_vm.dealerItem.Country))
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.dealerItem.Phone ||
          _vm.dealerItem.Mobile ||
          _vm.dealerItem.Fax ||
          _vm.dealerItem.Email
            ? _c("div", { staticClass: "dealer-item__row" }, [
                _vm.dealerItem.Phone
                  ? _c("p", { staticClass: "dealer-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DealerPhone) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "dealer-item__link",
                          attrs: { href: "tel:" + _vm.dealerItem.Phone }
                        },
                        [_vm._v(_vm._s(_vm.dealerItem.Phone))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dealerItem.Mobile
                  ? _c("p", { staticClass: "dealer-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DealerMobile) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "dealer-item__link",
                          attrs: { href: "tel:" + _vm.dealerItem.Mobile }
                        },
                        [_vm._v(_vm._s(_vm.dealerItem.Mobile))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dealerItem.Fax
                  ? _c("p", { staticClass: "dealer-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DealerFax) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "dealer-item__link",
                          attrs: { href: "tel:" + _vm.dealerItem.Fax }
                        },
                        [_vm._v(_vm._s(_vm.dealerItem.Fax))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dealerItem.Email
                  ? _c("p", { staticClass: "dealer-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DealerEmail) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "dealer-item__link",
                          attrs: { href: "mailto:" + _vm.dealerItem.Email }
                        },
                        [_vm._v(_vm._s(_vm.dealerItem.Email))]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dealerItem.ExtraInfo
            ? _c("div", { staticClass: "dealer-item__row" }, [
                _c("p", {
                  staticClass: "dealer-item__text dealer-item__text--extra",
                  domProps: { innerHTML: _vm._s(_vm.dealerItem.ExtraInfo) }
                })
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c63ab5dc", { render: render, staticRenderFns: staticRenderFns })
  }
}